import { Identifiable, Project } from "@planzone/dto";
import { Filter } from "@planzone/dto";

function isFilteredByProjectPortfolios(
  project: Identifiable<Project>,
  { projectPortfolios }: Filter,
) {
  return (
    !!projectPortfolios &&
    projectPortfolios.length > 0 &&
    !projectPortfolios
      .flat()
      .map(({ projects }) => projects)
      .flat()
      .map(({ uuid }) => uuid)
      .includes(project.uuid)
  );
}

export { isFilteredByProjectPortfolios };
